export default "__VITE_ASSET__BXRYNY4u__"